import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

/**
 * Mounts inside <BrowserRouter>. Fires a manual page_view on every SPA route
 * change. Skips the initial render — the gtag('config', ...) call in
 * index.html already sends the first page_view, so this prevents duplicates.
 */
export function PageTracker() {
  const location = useLocation();
  const isFirst = useRef(true);

  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
